import ApiService from './api.service'

class ImmoError extends Error {
  constructor(errorCode, message, errorFields) {
    super(message)
    this.name = this.constructor.name
    this.errorCode = errorCode
    this.message = message
    this.fields = errorFields
  }
}

const ImmoService = {
  createImmo: async function(immo) {
    try {
      const response = await ApiService.post(`/api/immo/`, immo)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },

  getImmo: async function(id) {
    try {
      const response = await ApiService.get(`/api/immo/${id}`)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },

  updateImmo: async function(immo) {
    try {
      const response = await ApiService.put(`/api/immo/${immo.id}`, immo)
      return response.data
    } catch (e) {
      console.log(e)
      throw new ImmoError(
        e.response.status,
        e.response.data.error,
        e.response.data.errors
      )
    }
  },

  deleteImmo: async function(id) {
    try {
      const response = await ApiService.delete(`/api/immo/${id}`)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },

  getImmoList: async function(filter) {
    try {
      const response = await ApiService.get('/api/immo', filter)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },

  getNote: async function(id) {
    try {
      const response = await ApiService.get(`/api/immo/${id}/note`)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },
  updateNote: async function(immoID, note) {
    try {
      const response = await ApiService.put(`/api/immo/${immoID}/note`, note)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },

  getImages: async function(id) {
    try {
      const response = await ApiService.get(`/api/immo/${id}/images`)
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  },
  deleteImage: async function(immoID, imageID) {
    try {
      const response = await ApiService.delete(
        `/api/immo/${immoID}/images/${imageID}`
      )
      return response.data
    } catch (e) {
      throw new ImmoError(e.response.status, e.response.data.error)
    }
  }
}

export default ImmoService

export { ImmoService, ImmoError }
